import { Action, Dispatch } from 'redux';
import { IAppState } from '../reducers';
import { getVendors } from '../../api/vault/vendors/api';
import { selectUserOrgIds } from '../user/userOrgRole';
import { getAllTeamsBySport, getTeams, getAllTeams } from '../../api/vault/teams';

export interface IVendorTeamWithData {
  teamName: string;
  teamCode: string;
  teamImage: string;
  exchangeQualifier: string[];
}

export interface IState {
  isOpen: boolean;
  isLoading: boolean;
  teams: IVendorTeamWithData[];
}

export enum ActionType {
  Toggle = 'VendorDataAction.Toggle',
  StartLoading = 'VendorDataAction.StartLoading',
  FinishLoading = 'VendorDataAction.FinishLoading',
  UpdateVendors = 'VendorDataAction.UpdateVendors',
  InitData = 'VendorDataAction.InitData',
}

export interface IVendorDataAction extends Action<ActionType> {
  payload?: any,
}

const INITIAL_STATE: IState = {
  isOpen: false,
  isLoading: false,
  teams: [],
};

export default function reducer(state: IState = INITIAL_STATE, action: IVendorDataAction): IState {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.StartLoading:
      return {
        ...state,
        isLoading: true,
      };
    case ActionType.FinishLoading:
      return {
        ...state,
        isLoading: false,
      };
    case ActionType.InitData:
      return {
        ...state,
        teams: action.payload.teams,
      };
    default:
      return state;
  }
}

export const getVendorTeams = async (isVendor: boolean, byVendorSport: boolean = false) => {
  if (isVendor) {
    return getAllTeamsBySport();
  }
  return byVendorSport ? getAllTeams() : getTeams();
};

export const toggleVendorData = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const {
    exchange: { vendorData: { isOpen } },
  } = getState();

  dispatch({ type: ActionType.Toggle });

  // Get vendors
  if (!isOpen) {
    dispatch({ type: ActionType.StartLoading });

    const teamsRes = await getAllTeamsBySport();
    const teamsData = teamsRes.data.data;

    const vendorsData = await getVendors();
    const userOrgId = selectUserOrgIds(getState())[0];
    const vendor = vendorsData.data?.data?.find((v) => v.orgId === userOrgId);
    const teamsWithData = (vendor?.vendorTeams || []).map(({ teamId, exchangeQualifier }) => {
      const teamData = teamsData?.find(({ _id }) => teamId === _id);
      const {
        TeamName = '', TeamImage = '', TeamCode = '',
      } = teamData || {};
      return {
        teamId,
        teamCode: TeamCode,
        exchangeQualifier,
        teamName: TeamName,
        teamImage: TeamImage,
      };
    }).sort((a, b) => {
      if (a.teamName < b.teamName) { return -1; }
      if (a.teamName > b.teamName) { return 1; }
      return 0;
    });

    if (!vendor) {
      dispatch({
        payload: { teams: [] },
        type: ActionType.InitData,
      });
    } else {
      dispatch({
        payload: { teams: teamsWithData },
        type: ActionType.InitData,
      });
    }
    dispatch({ type: ActionType.FinishLoading });
  }
};
